const FULLSCREEN_BODY_CLASS = 'ck-fullscreen';

export const isEditorFullscreen = (): boolean =>
  document.body.classList.contains(FULLSCREEN_BODY_CLASS);

/** Calls `onChange` whenever the editor enters or leaves fullscreen. */
export const observeEditorFullscreen = (onChange: () => void): (() => void) => {
  const observer = new MutationObserver(onChange);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
  return () => observer.disconnect();
};
